import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface Item5DescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Item5Description: React.FC<Item5DescriptionProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [item5, set_item5] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Expand Primary Structure']?.['Item #5']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Expand Primary Structure': { ...b.values?.['Expand Primary Structure'], 'Item #5': [v, b.values?.['Expand Primary Structure']?.['Item #5']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={item5}
                />
            ) : (
                <TextBox
                    value={item5}
                    onChange={(value) => set_item5(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
